import React from "react";

import {
  Dialog,
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextControl,
  Form,
  Divider,
  AutocompleteControl,
  Grid,
  FormControlLabel,
  Checkbox,
  InfoTooltip,
  Box,
} from "@tiny/components";
import { useAddSuppressionDialog } from "./AddSuppressionDialog.hooks";
import { suppressionTypes } from "./AddSuppressionDialog.helpers";
import { SuppressionData } from "../AddAudienceButton/AddAudienceButton";

export interface AddSuppressionDialogProps {
  open: boolean;
  onClose: () => void;
  onSuccess: (values: SuppressionData) => void;
}

function AddSuppressionDialog(props: AddSuppressionDialogProps) {
  const { open, onClose } = props;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="sm"
      disableEscapeKeyDown
      disableBackdropClose
    >
      <AddSuppressionDialogContent {...props} />
    </Dialog>
  );
}

function AddSuppressionDialogContent(props: AddSuppressionDialogProps) {
  const { onClose } = props;

  const {
    form,
    handleSubmit,
    continueAdding,
    executing,
    isGlobal,
    setIsGlobal,
  } = useAddSuppressionDialog(props);

  return (
    <>
      <DialogTitle subtitle="Name your suppression list." onClose={onClose}>
        Add new suppression list
      </DialogTitle>
      <DialogContent>
        <Form form={form} onSubmit={handleSubmit}>
          <Grid container direction="column" spacing={4}>
            <Grid item>
              <TextControl
                name="name"
                label="Suppression name"
                defaultValue=""
                required
                maxLength={140}
                placeholder="Give your suppression an easy to identify name"
              />
            </Grid>
            <Grid item>
              <AutocompleteControl
                required
                name="type"
                label="Suppression type"
                options={suppressionTypes}
                getOptionDisabled={(option) => option.disabled}
                getOptionLabel={(option) => option.label}
              />
            </Grid>
          </Grid>
        </Form>
        <Divider mt={4} />
      </DialogContent>
      <DialogActions
        extra={
          <FormControlLabel
            control={
              <Checkbox
                color="primary"
                checked={isGlobal}
                onClick={() => {
                  setIsGlobal(!isGlobal);
                }}
              />
            }
            label={
              <Box
                mt={1}
                display={"flex"}
                alignItems={"center"}
                justifyContent={"center"}
              >
                Mark as Global{" "}
                <InfoTooltip
                  title="Global suppressions are automatically applied to all campaigns by default."
                  size="medium"
                />
              </Box>
            }
          />
        }
      >
        <Button
          variant="contained"
          disabled={executing}
          onClick={continueAdding}
          loading={executing}
        >
          Continue
        </Button>
      </DialogActions>
    </>
  );
}

export default AddSuppressionDialog;
